import { Showcase } from "@/features/devtools/showcase";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/components")({
  component: Showcase,
});
